import React, { Component } from 'react';
import { renderClaveProdSATModal } from "./index";
import ValidateItems from './ValidateItems';
import $ from "jquery";
import '../css/Toogle.css';
import moment from 'moment';

class DataTablesCreateAux extends Component {
    constructor(props) {
        super(props);

        this.state = {
            refresh: true,
            switch1: false,
            PageNumber: 1,
            itemsPage: 10,
            rows: 10,
            searchInTable: '',
            checkboxArray: (new Map()),
            nextPage: false,
            previousPage: false,
            lastPage: false,
            firstPage: false,
            dateInit: "",
            dateFinal: "",
        };

        this.table = null;
        this.documentCreateModal = null;
    }

    componentDidMount() {
        const { searchInTable } = this.props;

        this.setState({ searchInTable: searchInTable });
        this.table = null;
        $('#searchDataTableCreateAux').val("");
        this.createDataTable();
    }

    shouldComponentUpdate = async (nextProps) => {
        if (this.props.view === 'claveProdSAT') {
            if (this.props.data.length !== nextProps.data.length && this.table !== null) {
                this.table.destroy();
                this.table = null;
            }
            return true;
        }
    }


    createDataTable = () => {
        this.table = $('#dataTableCreateAux').DataTable({
            "dom": '<"toolbar">frtip',
            "pagingType": "full_numbers",
            "paging": false,
            "info": false,
            "searching": false,
            "columnDefs": [{
                "targets": 0,
                "orderable": false
            }],
            responsive: true,
        });
        this.getTableInfoResult();
        this.changePaging();
    };

    getTableInfoResult = () => {
        let info = this.table.page.info();
        // console.log('con<info',info);
        let num = 0;

        if (info && info.recordsDisplay !== 0) {
            num = 1;
        }

        $('#tableInfoCreateAux').text((info.start + num) + " - " + info.end + " de " + info.recordsTotal);
        $('.dataTables_empty').text("No hay resultados por mostrar");
    };



    changePaging = () => {
        const { PageNumber, searchInTable } = this.state;
        let value = $('#changePaginateSelectAux').val();
        this.table.page.len("10").draw();
        this.getTableInfoResult();
    };

    changePagingItems = (event) => {
        // const {PageNumber,searchInTable} = this.state;
        // let value = event.nativeEvent.target.value;
        // this.table.page.len(value).draw();
        // this.getTableInfoResult();
        // this.setState({
        //     PageNumber:1,
        //     itemsPage : value || 10,
        //     rows:value
        //  });
        //  setTimeout(() => {
        //      this.searchDocument();
        //  }, 100);


    };

    componentWillUnmount() {
        this.table = null
    }

    toggleDocumentSelected = (id) => {
        const { action, } = this.props;
        this.setState(state => {
            const checkboxArray = new Map(state.checkboxArray);
            checkboxArray.set(id, !checkboxArray.get(id)); // toggle
            return { checkboxArray };
        });

        setTimeout(() => {
            const { checkboxArray } = this.state;
            action(checkboxArray)
        }, 100);
        // console.log('con<vflagInvoices',flagInvoices,'-----', this.state.checkboxArray.size);
    };

    toggleDocumentSelectedAll = (option) => {
        const { data, action } = this.props;
        let newCheckbox = (new Map());
        data.map((register, index) => {
            newCheckbox.set(index, option)
        });
        this.setState({
            checkboxArray: newCheckbox
        });

        setTimeout(() => {
            const { checkboxArray } = this.state;
            action(checkboxArray)
        }, 100);

    };

    renderTable = () => {
        const { view, headers, data, action, edditAddres, indexPurchaseRequest, DisabledItems, flagInvoices } = this.props;
        const { checkboxArray, switch1 } = this.state;
        // console.log('con<data',data);
        let table = "";

        let checkbox = {
            data: checkboxArray,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }

        switch (view) {
            case 'claveProdSAT':
                table = renderClaveProdSATModal(headers, data, action, switch1);
                break;

            default:
                table = "";
        }
        return table;
    };

    searchInTable = key => {
        const { view, search } = this.props;
        let value = key.target.value;

        this.setState({
            searchInTable: value,
        });
        let tabla = $('#dataTableCreateAux').DataTable();
        tabla.search(value);
        tabla.draw();
        this.getTableInfoResult();

    }

    addToTable = () => {
        const { addItemBack, } = this.props;
        const { nextPage, previousPage, firstPage, lastPage } = this.state;

        if (nextPage) {
            this.nextPages();
            this.resetPage();
        }
        if (previousPage) {
            this.previousPages();
            this.resetPage();
        }
        if (firstPage) {
            this.firstPages();
            this.resetPage();
        }
        if (lastPage) {
            this.lastPages();
            this.resetPage();
        }
        addItemBack();
    }

    continuePage = () => {
        const { nextPage, previousPage, firstPage, lastPage } = this.state;
        if (nextPage) {
            this.nextPages();
            this.resetPage();
        }
        if (previousPage) {
            this.previousPages();
            this.resetPage();
        }
        if (firstPage) {
            this.firstPages();
            this.resetPage();
        }
        if (lastPage) {
            this.lastPages();
            this.resetPage();
        }
    }

    resetPage() {
        this.setState({
            nextPage: false,
            previousPage: false,
            firstPage: false,
            lastPage: false
        });
    }

    first = () => {
        const { view, saveData } = this.props;
        const { PageNumber, rows, checkboxArray } = this.state;
        if (view === 'partnerModal' || view === 'itemsModal') {
            this.setState({
                firstPage: true
            });
            let bandera = true;
            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.firstPages();
            }
        } else {
            this.table.page('first').draw('page');
            this.getTableInfoResult();
        }


    }

    firstPages = () => {
        const { view } = this.props;

        this.setState({
            PageNumber: 1,
            rows: 10
        });
        setTimeout(() => {
            this.searchDocument();
        }, 100);



    }

    previous = () => {
        const { PageNumber, rows, checkboxArray } = this.state;
        const { view, saveData } = this.props;
        if (view === 'partnerModal' || view === 'itemsModal') {
            this.setState({
                previousPage: true
            });
            let bandera = true;

            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.previousPages();
            }

        } else {
            this.table.page('previous').draw('page');
            this.getTableInfoResult();
        }
    }

    previousPages = () => {
        const { PageNumber, rows } = this.state;
        const { view } = this.props;
        let previousPage = PageNumber;
        let row = rows;
        if ((PageNumber - 1) > 0) {
            previousPage -= 1;
            if (row - 10 > 0) {
                row -= 10;
            }

        }
        this.setState({
            PageNumber: previousPage,
            rows: row,
        });
        setTimeout(() => {
            this.searchDocument();
        }, 100);
    }

    next = () => {
        const { rows, PageNumber, checkboxArray } = this.state;
        const { view, totalPage, saveData } = this.props;
        if (view === 'partnerModal' || view === 'itemsModal') {
            this.setState({
                nextPage: true
            });
            let bandera = true;

            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.nextPages();
            }

        } else {
            this.table.page('next').draw('page');
            this.getTableInfoResult();
        }
    }

    nextPages = () => {
        const { rows, PageNumber, checkboxArray } = this.state;
        const { view, totalPage } = this.props;
        let total = totalPage || 10
        let last = Math.ceil(total / 10);
        let nexPage = PageNumber;
        let row = rows;
        if (PageNumber < last) {
            nexPage += 1;
            if (row < total - 10) {
                row += 10;
            }
        }
        this.setState({
            PageNumber: nexPage,
            rows: row
        });

        setTimeout(() => {
            this.searchDocument();
        }, 100);
    }

    last = () => {
        const { rows, checkboxArray } = this.state;
        const { totalPage, view, saveData } = this.props;

        if (view === 'partnerModal' || view === 'itemsModal') {
            this.setState({
                lastPage: true
            });
            let bandera = true;

            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.lastPages();
            }
        } else {
            this.table.page('last').draw('page');
            this.getTableInfoResult();
        }
    }

    lastPages = () => {
        const { rows } = this.state;
        const { totalPage, view } = this.props;


        let total = totalPage || 10;
        let last = Math.ceil(total / 10);
        let row = rows;
        row = (last - 1) * 10;

        this.setState({
            PageNumber: last,
            rows: row
        });

        setTimeout(() => {
            this.searchDocument();
        }, 100);

    }

    searchDocument = async () => {
        const { search } = this.props;
        const { PageNumber, searchInTable, itemsPage } = this.state;
        search(searchInTable, PageNumber);

        //limpiar checkbox
        this.setState({
            checkboxArray: new Map()
        });
    };

    searchDocuments = async () => {
        const { view, search, filterByDate } = this.props;
        const { checkboxArray, PageNumber } = this.state;
        let date = {
            // dateInit: moment(document.getElementById("fechaInicioSelectOf").value).format('YYYYMMDD'),
            // dateFinal: moment(document.getElementById("fechaFinSelectOf").value).format('YYYYMMDD'),
            dateInit: null,
            dateFinal: null
        };


        if (view === 'selectOfModal') {
            const { search } = this.props;
            await search(date);
        } else if (view === 'invoicesPaymentModal' && filterByDate) {
            date = {
                dateInit: moment(document.getElementById("fechaInicioInvoices").value).format('YYYYMMDD'),
                dateFinal: moment(document.getElementById("fechaFinInvoices").value).format('YYYYMMDD'),
            };
            this.toggleDocumentSelectedAll(false);

            this.setState({
                checkboxDataTables: (new Map()),
            });
            search(date);
        } else {
            date = {
                PageNumber
            }

            search(date);

        }
    };

    refreshDates = () => {
        // setTimeout(()=> {
        //     document.getElementById("fechaInicioSelectOf").value = moment(new Date()).format('YYYY-MM-DD');
        //     document.getElementById("fechaFinSelectOf").value = moment(new Date()).format('YYYY-MM-DD');
        // },100)
    };

    handleSwitchChange = nr => () => {
        const { switch1 } = this.state;
        let switchNumbers = `switch${nr}`;
        this.setState({
            switch1: !this.state[switchNumbers]
        });
        // this.render();
    }

    render() {
        const { view, headers, totalPage, showStock, filterByDate } = this.props;
        const { details, billingResponseArray, seriesArray, seriesDefault, newOrderModel, switch1, PageNumber, rows, searchInTable, itemsPage, checkboxArray, nextPage } = this.state;

        return (
            <div>
                <ValidateItems
                    addToTable={this.addToTable}
                    nextPage={nextPage}
                    nextPages={this.nextPages}
                    continuePage={this.continuePage} />


                <div className="search-div row">
                    <div className="col-md-12" style={{ width: '100%' }}>
                        <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc'
                            style={{ display: 'inline-flex' }} placeholder="Buscar" autoComplete="off"
                            id='searchDataTableCreateAux'
                            type='search' aria-controls='dataTableTimbra' value={searchInTable || ''} onChange={this.searchInTable} />
                    </div>

                </div>

                {/* {view === 'itemsModal' &&
                <div className="search-div row">
                    <div className=" col-md-2"></div>
                    <div className=" col-md-4"></div>
                        <div className=" col-md-6">
                                <label>
                                    Mostrar artículos solo con stock disponible  
                                </label>
                                &nbsp;
                                <label className="switch" >
                                    <input type="checkbox"  
                                    checked={switch1} 
                                    onChange={this.handleSwitchChange(1)}/>
                                    <span className="slider round"></span>
                                </label>
                        </div>
                </div>} */}

                <div className="w-100 table-scroll">
                    {this.renderTable()}
                </div>
                <div className="navigation-tabs " style={{ textAlign: "right" }}>
                    <div className="form-row navigation-tabs2">



                    </div>
                </div>
                <br></br>

            </div>
        );
    }
}

export default DataTablesCreateAux;